// extracted by mini-css-extract-plugin
module.exports =  {"items":"items--C+BHeWpHyjh7KgyUwB7QsA=="};